import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import AppWrapper from 'components/app';
import store from 'store';
import 'semantic-ui-css/semantic.min.css';
import ProfileContainer from 'containers/profile';
import ErrorBoundary from 'components/error/boundary';
import { Error500 } from 'components/pages';
import '@fontsource/roboto';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/900.css';

render(
  <Provider store={store}>
    <AppWrapper>
      <ErrorBoundary Fallback={Error500}>
        <ProfileContainer />
      </ErrorBoundary>
    </AppWrapper>
  </Provider>,
  document.getElementById('root')
);
